<template>
  <div>
    <loading-panel :visible="loading"></loading-panel>
    <div class="header pb-8 pt-4 pt-lg-5 d-flex profile-header"
        style="min-height: 100vh; background-image: url(img/theme/header-background.png); background-size: cover; background-position: center top;">
      <b-container fluid class="mt-6">
        <b-row >
          <b-col cols="8">
            <h4 class="display-4 text-dark">{{ $t('admin.carousel.pageTitle') }}</h4>
          </b-col>
          <b-col align="right">
          <el-tooltip placement="bottom" :content="$t('tooltip.add')">
            <b-link to="/blogs/0">
              
                <i class="icon-sm"><b-img alt="..." src="./img/icons/common/add.svg" /></i>
              
            </b-link>
            </el-tooltip>
          </b-col>
        </b-row>        
        <b-row>
          <b-col xl="12">
            <div class="table">
              <b-row align-v="center" class="header">
                  <b-col md="4" cols="3">
                      {{ $t('admin.carousel.title') }}
                  </b-col>
                  <b-col md="4" cols="3">
                      {{ $t('admin.carousel.url') }}
                  </b-col>
                  <b-col md="2" cols="3" class="text-center">
                      {{ $t('admin.carousel.image') }}
                  </b-col>  
                  <b-col md="2" cols="3" class="text-center"> 
                      {{ $t('admin.carousel.actions') }}                
                  </b-col>         
              </b-row>
              <sortable v-for="(item, index) in blogs"
                v-model="dragData" 
                :key="item.car_id" 
                :index="index" 
                drag-direction="vertical" 
                replace-direction="vertical" 
                @sortend="sortend($event, blogs)"
          
                @real-click="click"
              >
                  <b-row align-v="center" class="list-item">
                      <b-col md="4" cols="3" class="ellipsis">
                          <el-tooltip placement="bottom" :content="item.carousellangs[0].cln_title">
                            <span>{{ item.carousellangs[0].cln_title }}</span>
                          </el-tooltip>    
                      </b-col>
                      <b-col md="4" cols="3" class="ellipsis">
                        <el-tooltip placement="top" :content="item.carousellangs[0].cln_url">
                          <a :href="item.carousellangs[0].cln_url" target="_blank">
                            {{ item.carousellangs[0].cln_url }}
                          </a>
                        </el-tooltip>
                      </b-col>
                      <b-col md="2" cols="3" class="text-center">
                          <div class="avatar-group">
                              <a class="avatar avatar-md" :href="item.carousellangs[0].cln_url" target="_blank"
                                :data-original-title="item.carousellangs[0].cln_image">
                                  <img alt="..." :src="item?imageBaseUrl + item.carousellangs[0].cln_image:''"/>
                              </a>
                          </div>
                      </b-col>  
                      <b-col md="2" cols="3" class="text-center"> 
                          <b-row class="m-0">
                              <b-col cols="4" align="right" class="p-0">
                                <el-tooltip placement="bottom" :content="$t('tooltip.edit')">
                                  <a href="javascript:void(0)" class="icon action-edit" @click="editBlog(item.car_id)">
                                      <i><img src="img/icons/common/edit.svg"/></i>
                                  </a>
                                </el-tooltip>
                              </b-col>
                              <b-col cols="4" align="center" class="p-0">
                                <el-tooltip placement="bottom" :content="$t('tooltip.delete')">
                                  <a href="javascript:void(0)" class="icon action-delete" @click="deleteBlog(index)">
                                      <i><img src="img/icons/common/trash.svg"/></i>
                                  </a>
                                </el-tooltip>
                              </b-col>
                              <b-col cols="4" align="left" class="p-0">
                                  <a href="javascript:void(0)" class="icon action-drag">
                                      <i><img src="img/icons/common/grip-vertical-solid.svg"/></i>
                                  </a>
                              </b-col>                    
                          </b-row>                
                      </b-col>         
                  </b-row>
              </sortable>
                  <b-row align-v="center" class="list-item"></b-row>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
  import Vue from "vue";
  import { Table, TableColumn} from 'element-ui';
  import { mapActions } from "vuex";
  import Sortable from 'vue-drag-sortable';
  export default {
    name: 'blogs-list',    
    components: {
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      Sortable
    },
    data() {
      this.loadCarousels();
      return {
        lang: Vue.i18n.locale(),
        blogs: [],
        imageBaseUrl: process.env.VUE_APP_APIURL + "image/",

        dragData: {},
        loading: false
      };
    },
    methods: {
        ...mapActions(["GetListCarousels", "UpdateOrder", "DeleteCarousel"]),
        async loadCarousels() {
            let lan = Vue.i18n.locale();
            await this.GetListCarousels(lan)
            this.blogs = this.$store.getters.AllCarousels;            
        },
        editBlog(id) {
            this.$router.push({ path: `/blogs/${id}` });
        },
        async deleteBlog(index) {
          this.loading = true;
          this.blogs = this.$store.getters.AllCarousels;
          let blogToDelete = this.blogs[index];
          await this.DeleteCarousel(blogToDelete.car_id);
          this.blogs = this.$store.getters.AllCarousels;
          this.loading = false;
        },
        onTranslate(){
;
        },
        async exchangeLang() {
            this.lang == 'fr'?this.lang = 'en':this.lang = 'fr';
            await this.GetListCarousels(this.lang);
            this.blogs = this.$store.getters.AllCarousels
        },
        click (e) {
        // Todo
        },
        sort (e) {
          const { oldIndex, newIndex } = e
        },
        sortend (e, list) {
          const { oldIndex, newIndex } = e
          this.rearrange(list, oldIndex, newIndex)
        },
        async rearrange (array, oldIndex, newIndex) {
          this.loading = true;
          let body = {
              lan_code: Vue.i18n.locale(),
              car_id: array[oldIndex].car_id,
              car_order: newIndex + 1
          }
          await this.UpdateOrder(body);
          this.blogs = this.$store.getters.AllCarousels;
          this.loading = false;
        }
    }
  }
</script>
